import { makeVar } from '@apollo/client';

export const usernameSearch = makeVar<string>('');
